import EventRegistrationRequestModelBase from '../_generated/modelBases/event-registration-request-model-base';

export default class EventRegistrationRequestModel extends EventRegistrationRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
